// Хранилище на устройстве (IndexedDB): справочник товаров и документы, которые ждут отправки.
// Переживает перезагрузку страницы, закрытие вкладки и выключение устройства.
const DB = 'mpwms-offline';
const STORE = 'kv';
let dbp: Promise<IDBDatabase> | null = null;
const mem = new Map<string, unknown>();   // запасной вариант, если IndexedDB недоступна (приватный режим)

function open(): Promise<IDBDatabase> {
  dbp ??= new Promise((resolve, reject) => {
    const req = indexedDB.open(DB, 1);
    req.onupgradeneeded = () => req.result.createObjectStore(STORE);
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
  return dbp;
}
async function tx<T>(mode: IDBTransactionMode, fn: (s: IDBObjectStore) => IDBRequest<T>): Promise<T> {
  const db = await open();
  return new Promise((resolve, reject) => {
    const r = fn(db.transaction(STORE, mode).objectStore(STORE));
    r.onsuccess = () => resolve(r.result);
    r.onerror = () => reject(r.error);
  });
}
export async function kvGet<T>(key: string): Promise<T | undefined> {
  try { return await tx<T>('readonly', (s) => s.get(key)); } catch { return mem.get(key) as T | undefined; }
}
export async function kvSet(key: string, value: unknown): Promise<void> {
  try { await tx('readwrite', (s) => s.put(value, key)); } catch { mem.set(key, value); }
}
export async function kvDel(key: string): Promise<void> {
  try { await tx('readwrite', (s) => s.delete(key)); } catch { mem.delete(key); }
}
export async function kvKeys(prefix: string): Promise<string[]> {
  try { return ((await tx<IDBValidKey[]>('readonly', (s) => s.getAllKeys())) as string[]).filter((k) => String(k).startsWith(prefix)); }
  catch { return [...mem.keys()].filter((k) => k.startsWith(prefix)); }
}
